export class SetActiveProjectsTypeFilter {
    public static readonly type = "[Projects] Save active projects type filter";

    constructor(public payload: string) {}
}
